<template>
	<canvas 
		:id="identify" 
		:width="width"
		:height="height">		
	</canvas>
</template>

<script>
	export default {
		props:['identify', 'data', 'width', 'height'],
		mounted(){
			if(this.data.data != undefined){
				if(this.data.data.datasets[0] != undefined){
					this.setChart();
				}
			}
		},
		methods: {
			setChart(){
				Chart.defaults.global.defaultFontFamily = '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
				Chart.defaults.global.defaultFontColor = '#292b2c';
				var ctx = document.getElementById(this.identify).getContext('2d');
				var myLineChart = new Chart(ctx, this.data);
			}
		}
	}
</script>	